import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {ProductLatestDownloadBrochuresFields, ProductLatestDownloadBrochuresProps} from '../types/productLatestDownloadBrochures.types'
import { TIconFromRenderingParams } from '../../../types/sitecore.types';
import { TProductDownloadBrochuresDataAssets } from '../../@shared/productDownloadBrochures/types/productDownloadBrochures.types';

export class ProductLatestDownloadBrochuresModel {

    private readonly fields?: ProductLatestDownloadBrochuresFields;
    private readonly rendering?: ComponentRendering;

    constructor(props:  ProductLatestDownloadBrochuresProps) {
      this.fields = props.fields || undefined;
      this.rendering = props?.rendering;
    }

    get iconList(): Array<TIconFromRenderingParams> {
      return this.fields?.itemData?.iconsList || [];
    }

    get items(): Array<TProductDownloadBrochuresDataAssets> {
      return this.fields?.apiData.items || [];
    }
}
